import { useState } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, IconButton } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { useCartStore } from '../../stores/cartStore';
import { useUserStore } from '../../stores/userStore';
import CartAddress from './components/CartAddress';
import CartInfo from './components/CartInfo';

const CartPage = () => {
  const navigate = useNavigate();

  const companyInfo = useUserStore((state) => state.companyInfo);
  const redeemLists = useCartStore((state) => state.cart);

  const [step, setStep] = useState(1);

  const disabledButton = companyInfo?.address?.length > 0 && redeemLists.length > 0 ? false : true;

  return (
    <>
      <Helmet>
        <title>Shopping cart | Caltex StarCard</title>
      </Helmet>

      <Box sx={{ padding: '10px 16px 60px 16px' }}>
        <IconButton
          onClick={() => navigate('/reward')}
          sx={{
            width: '100px',
            height: '40px',
            fontSize: '1.25rem',
            color: 'white',
            margin: '10px 0 20px',
            backgroundColor: '#8E8E8E',
            padding: '2px 10px',
            borderRadius: '8px',

            '&:hover': {
              color: 'white',
              backgroundColor: '#8E8E8E',
              opacity: '.85',
            },
          }}
        >
          <ArrowBackIosIcon
            sx={{
              fontSize: '1rem',
              fontWeight: '400',
              color: 'white',
            }}
          />
          ย้อนกลับ
        </IconButton>

        {step === 1 && <CartInfo disabledButton={disabledButton} onConfirm={() => setStep(2)} />}
        {step === 2 && <CartAddress disabledButton={disabledButton} />}
      </Box>
    </>
  );
};

export default CartPage;
